type EnvKey = 'DEV' | 'STAGING' | 'PRE-PROD' | 'PROD';

interface EnvConfig {
  telegramBotId: string,
  telegramBotName: string;
  googleClientId: string;
  xClientId: string;
  lineClientId: string;
}

export const AppEnvConfig: Record<EnvKey, EnvConfig> = {
  "DEV": {
    telegramBotId: '7549910036',
    telegramBotName: "tlgm_auth_bot",
    googleClientId: "757849354614-qcb25jnhs1pte88gu9nou5r8nd7c52ug.apps.googleusercontent.com",
    xClientId: 'TV9fUE9pblRDNmVpUXBHbWZIV0E6MTpjaQ',
    lineClientId: "2007230185"
  },

  "STAGING": {
    telegramBotId: '7549910036',
    telegramBotName: "tlgm_auth_bot",
    googleClientId: "757849354614-qcb25jnhs1pte88gu9nou5r8nd7c52ug.apps.googleusercontent.com",
    xClientId: 'TV9fUE9pblRDNmVpUXBHbWZIV0E6MTpjaQ',
    lineClientId: "2007230185"
  },

   "PRE-PROD": {
    telegramBotId: '8032855237',
    telegramBotName: "YoloPreprodTgAuthDesktop_bot",
    googleClientId: "941961551750-jsvar6dltpn2joc3cnr5cumj0kcn666c.apps.googleusercontent.com",
    xClientId: 'MkkwMnY0TEpSQzAwZVlabFQ2WlA6MTpjaQ',
    lineClientId: "2007448729"
  },

  "PROD": {
    telegramBotId: '8168564507',
    telegramBotName: "YoloTgAuthDesktop_bot",
    googleClientId: "941961551750-jsvar6dltpn2joc3cnr5cumj0kcn666c.apps.googleusercontent.com",
    xClientId: 'MkkwMnY0TEpSQzAwZVlabFQ2WlA6MTpjaQ',
    lineClientId: "2007448729"
  },
};
